import type { MaterialAdapted } from "~/common/interfaces/entities/material.interface";

export const getMaterialDefault = (): MaterialAdapted => ({
	id: 0,
	name: "",
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	translations: [],
	colors: []
});
